import axios from 'axios';
import { API_BASE_URL } from '../constants/api';

// Configure auth axios instance
const authApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const login = async (email, password) => {
  try {
    const response = await authApi.post('/users/login', { email, password });
    
    // Store token in localStorage
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    
    return response.data;
  } catch (error) {
    console.error('Login Error:', error);
    throw new Error(error.response?.data?.message || 'Invalid credentials');
  }
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

export const getCurrentUser = () => {
  const token = localStorage.getItem('token');
  if (!token) return null;
  
  // Try to get user from localStorage first
  const savedUser = localStorage.getItem('user');
  if (savedUser) {
    try {
      return JSON.parse(savedUser);
    } catch (e) {
      // If parsing fails, remove the invalid data
      localStorage.removeItem('user');
    }
  }
  
  // Fallback to mock user
  return {
    id: 1,
    username: 'Admin User',
    email: 'admin@example.com',
    role: 'admin'
  };
};

export const isAuthenticated = () => {
  return !!localStorage.getItem('token');
}; 